jQuery(document).on("mousedown", ".stacked-slider .active .next", function () {
    if (jQuery(this).parents().eq(1).next().length != 0) {
        jQuery(this).parents().eq(1).addClass("toLeft");
        jQuery(this).parents().eq(1).next().addClass("active");
        jQuery(".stacked-slider-navigation .active")
            .removeClass("active")
            .next()
            .addClass("active");
    }
});

jQuery(document).on("mousedown", ".stacked-slider .active .prev", function () {
    if (jQuery(this).parents().eq(1).prev().length != 0) {
        jQuery(this).parents().eq(1).removeClass("active");
        jQuery(this).parents().eq(1).prev().addClass("active");
        jQuery(this).parents().eq(1).prev().removeClass("toLeft");
        jQuery(".stacked-slider-navigation .active")
            .removeClass("active")
            .prev()
            .addClass("active");
    }
});

jQuery(document).on("click", ".stacked-slider-navigation li", function () {
    jQuery(".stacked-slider-navigation li").removeClass("active");
    jQuery(this).addClass("active");

    var t = jQuery(this).index();

    jQuery(".stacked-slider__slide").removeClass("active toLeft");

    jQuery(".stacked-slider__slide").each(function (index) {
        var _this = this;

        if (index < t) {
            setTimeout(function () {
                jQuery(_this).addClass("toLeft");
            }, 100 * index);
        }
    });

    t = parseInt(t + 1);
    jQuery(".stacked-slider__slide:nth-of-type(" + t + ")").addClass("active");
});
